import { render, staticRenderFns } from "./InputAttachment.vue?vue&type=template&id=2b626a16&scoped=true&"
import script from "./InputAttachment.vue?vue&type=script&lang=js&"
export * from "./InputAttachment.vue?vue&type=script&lang=js&"
import style0 from "./InputAttachment.vue?vue&type=style&index=0&id=2b626a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b626a16",
  null
  
)

export default component.exports